import type { StageConfig } from '@capture/shared';
import { StageDeepLinks } from './StageDeepLinks';

export function OcrPanel({ config, onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  const mode = (config.config.mode as string) ?? 'full-page';
  const engine = (config.config.engine as string) ?? 'default';
  return (
    <div className="stage-panel">
      <label>
        Mode
        <select value={mode} onChange={(e) => onChange({ ...config, config: { ...config.config, mode: e.target.value } })}>
          <option>full-page</option>
          <option>zone-targeted</option>
        </select>
      </label>
      <label>
        Engine
        <select value={engine} onChange={(e) => onChange({ ...config, config: { ...config.config, engine: e.target.value } })}>
          <option>default</option>
          <option>tesseract</option>
          <option>cloud-vision</option>
        </select>
      </label>
      <StageDeepLinks stage="ocr" />
    </div>
  );
}
